import gql from 'graphql-tag';

export const ADD_ITEMBANK_CONTENT_CONFIG_QUERY = gql`
  query addItemBankContentConfigQuery($id: ID!) {
    addItemBankContentConfig(id: $id) {
      availableSections {
        code
        displayName
      }
      availableContextTypes
      availableItemTypes
      availableItemAnswerTypes {
        itemAnswerTypeId
        itemAnswerType
        itemType
        sectionCode
      }
      availableValenceTypes
      availableContexts {
        id
        code
        itemType
        sectionCode
      }
      availableReportTextTypes
      availableTextLevels {
        reportTextType
        levels
      }
      availableSequences {
        reportTextType
        level
        sequences
      }
    }
  }
`;

export const ADD_BEHAVIOR_ITEM_BANK_CONTENT = gql`
  mutation addBehaviorItemBankContentMutation($input: AddBehaviorItemBankContentInput!) {
    addBehaviorItemBankContent(input: $input) {
      dimensionCode
    }
  }
`;

export const ADD_COGNITIVE_ITEM_BANK_CONTENT = gql`
  mutation addCognitiveItemBankContentMutation($input: AddCognitiveItemBankContentInput!) {
    addCognitiveItemBankContent(input: $input) {
      dimensionCode
    }
  }
`;
